// extracted by mini-css-extract-plugin
export default {"table":"styles_table__kHFUP","cell":"styles_cell__E4dw2"};